import Store from './Store';
import structure from '../data/ressources/User';

const UserStore = new Store('users',structure);

export {UserStore};